/**
 * pdf预览
 */
import React from 'react';
import { WizComponent, WizPagination } from 'wiz-components'
import { Page } from 'react-pdf'
import { Document } from 'react-pdf/dist/esm/entry.webpack';
import ReactDOM from 'react-dom'
import './index.less'

export default class PdfStudy extends WizComponent {
    constructor(props) {
        super(props);
        this.state = {
            numPages: 0,
            pageNumber: 1,
            showPage: false
        };
    }

    componentDidMount() {
        this._renderPDF();
        // 禁用右键
        window.document.oncontextmenu = function () {
            return false;
        }
    }

    //   pdf加载成功回调方法
    onDocumentLoad = ({ numPages }) => {
        this.setState({ numPages, showPage: true });
    }

    // 翻页
    onChangePage = (page) => {
        this.setState({ pageNumber: page }, () => {
            let dom = document.querySelector('#PDFView')
            dom.scrollTo(0, 0)
            this._renderPDF()
        });
    }

    //   pdf展示组件
    _renderPDF = () => {
        let o = document.querySelector('#pdf_content');
        let pWidth = o.offsetWidth
        const { pageNumber } = this.state
        let { url, unPdfLoad } = this.props
        ReactDOM.render((
            <div>
                <Document
                    //文件路径,
                    file={url}
                    //加载成功调用
                    onLoadSuccess={this.onDocumentLoad}
                    //加载失败调用
                    onLoadError={(e) => { unPdfLoad && unPdfLoad() }}
                    loading="正在加载中" //加载时提示语句
                    externalLinkTarget="_blank"
                    error='加载文件失败，请稍后再试'
                >
                    <Page pageNumber={pageNumber} width={pWidth - 30} />
                </Document>
            </div>
        ), document.getElementById('PDFView'));
    }

    // 翻页组件
    _renderPages = () => {
        const { numPages, pageNumber, showPage } = this.state
        return showPage ?
            <div className='pdf-pages'>
                <WizPagination
                    total={numPages}
                    showTotal={total => `共 ${total} 页`}
                    current={pageNumber}
                    pageSize={1}
                    simple={true}
                    onChange={this.onChangePage}
                />
            </div>
            : null
    }

    render() {
        return (
            <div id={'pdf_content'}>
                <div className='pdf-view' id='PDFView'></div>
                {this._renderPages()}
            </div>
        )
    }
}
